module.exports = __webpack_public_path__ + "img/online-experience-banner.7e56bfc6.jpg";